import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { IEmojiDialogProps } from "./~types/EmojiDialogProps";
import "./EmojiDialog.css";

const EmojiDialog = (props: IEmojiDialogProps) => {
    const [emojiDialogVisibility, setEmojiDialogVisibility] = useState(false);

    return (
        <Dropdown
            isOpen={emojiDialogVisibility}
            toggle={() => {
                setEmojiDialogVisibility(!emojiDialogVisibility);
            }}
        >
            <DropdownToggle className="smiles-container-dropdownToggle">
                <i className="material-icons smiles-button">
                    sentiment_satisfied_alt
                </i>
            </DropdownToggle>
            {emojiDialogVisibility && (
                <DropdownMenu>
                    <div className="smiles-container">
                        <Picker
                            autoFocus
                            data={data}
                            onEmojiSelect={props.onEmojiClick}
                        />
                    </div>
                </DropdownMenu>
            )}
        </Dropdown>
    );
};

export default EmojiDialog;